import * as React from 'react'
import * as D from '../domain'
import { BallotVariant } from '../materials'

export interface BallotContextValue {
  ballotVariant: BallotVariant
  ballotDocumentBase: D.BallotDocumentBase
}

export const defaultBallotContextValue: BallotContextValue = {
  ballotVariant: 'default',
  ballotDocumentBase: {
    /*
     * BallotStateDocument
     */
    trend: undefined,
    projection: undefined,
    result: undefined,

    /*
     * BallotDocumentBase
     */
    position: 1,

    name: D.emptyMultiLocaleString,
    lead: D.emptyMultiLocaleString,

    detailName: D.emptyMultiLocaleString,

    articleIds: D.emptyMultiLocaleString,

    group: undefined,

    sideLabels: undefined,
  },
}

export const BallotContext = React.createContext<BallotContextValue>(defaultBallotContextValue)

export const useBallotContext = () => {
  return React.useContext(BallotContext)
}

interface BallotContextProviderProps {
  ballotId: string
  ballotDocumentBase: undefined | D.BallotDocumentBase
  children?: React.ReactNode
}

export function BallotContextProvider({ ballotId, ballotDocumentBase, children }: BallotContextProviderProps) {
  const value: BallotContextValue = (() => {
    if (ballotDocumentBase === undefined) {
      return defaultBallotContextValue
    } else {
      return {
        ballotVariant: D.isTiebreakQuestion(ballotId, ballotDocumentBase)
          ? ('tieBreak' as const)
          : ('default' as const),
        ballotDocumentBase,
      }
    }
  })()

  return <BallotContext.Provider value={value}>{children}</BallotContext.Provider>
}
